import { h} from 'preact';
import { useState } from 'preact/hooks';
import Markup from 'preact-markup';
import { Text, MarkupText } from 'preact-i18n';
import Carousel from 'preact-flickity-component';
import '../../../node_modules/flickity/dist/flickity.css';

const GetEventUrl =  function(eventBlock) {
  try {
    if ( eventBlock && eventBlock.offers && eventBlock.offers.length > 0 &&
          eventBlock.offers[0].potentialAction && eventBlock.offers[0].potentialAction.length > 0 && eventBlock.offers[0].potentialAction[0].url ) {
      return eventBlock.offers[0].potentialAction[0].url;
    } else return ("");
  } catch(ex) {
    // do nothing for now
  }
  return ("");
}

export const OneEventCard = props => {
  try {
    const [eventBlock, setEventBlock] = useState(props.eventBlock);
    let location = (eventBlock && eventBlock.location && eventBlock.location.name) ? eventBlock.location.name : null;
    let url =  GetEventUrl(eventBlock);
    let date = eventBlock.startDate ? new Date(eventBlock.startDate) : null;
    if(!location || !url || !date) {
      return ("");
    }

    let categorie = "";
    if (eventBlock.categories && eventBlock.categories.length > 0) {
      let categories = eventBlock.categories;
      categorie = eventBlock.categories[0];
      for (let i = 1; i < categories.length; i++) {
        categorie += " • " + categories[i];
        
      }
    }
    let month = date.toLocaleString('default', { month: 'short' });
    let weekday = date.toLocaleString('default', { weekday: 'short' });
    let day = date.getDate();
    let time = date.toLocaleString('default', {hour: '2-digit', minute: '2-digit'});
    let minPrice = (eventBlock.offers && eventBlock.offers.length >0 && eventBlock.offers[0].priceSpecification && 
                    eventBlock.offers[0].priceSpecification.minPrice && eventBlock.offers[0].priceSpecification.priceCurrency) ?
                    " • " + eventBlock.offers[0].priceSpecification.minPrice + "+ " + eventBlock.offers[0].priceSpecification.priceCurrency : "";
    let timePrice = time + minPrice;
  
    return (
      <div className="ae-border-box">
        <div className="event-card">
          <a className="ae-dark" href={url} target="_blank">
            <div className='event-block'>
              <div className='event-date'>
                <div className='ae-link-text'>{month}</div>
                <div className='ae-subheadline ae-link-text'>{day}</div>
                <div className='ae-link-text'>{weekday}</div>
              </div>
              <div>
                {( eventBlock.performer && eventBlock.performer.length > 0 ) ? 
                  <div className="ae-subtitle-large event-performer"><Markup className="ae-ellipsis-1" markup={eventBlock.performer[0].name} type="html" trim={false}/></div> :
                  <Text className="result-title" id="newSearch.eventAt" fields={{ eventPlace: location }}>Event at: {location}</Text>
                }
                <div className="ae-para event-category"><Markup className="ae-ellipsis-1" markup={categorie} type="html" trim={false}/></div>
                <div className="ae-para event-location"><Markup className="ae-ellipsis-1" markup={location} type="html" trim={false}/></div>
                <div className="ae-para event-price"><Markup className="ae-ellipsis-1" markup={timePrice} type="html" trim={false}/></div>
              </div>
            </div>
          </a>
        </div>
      </div>
    )
  } catch(ex) {
    // do nothing for now
  }
  return ("");
}
export const Event = props =>  {
  try {
    const [item, setItem] = useState(props.item);
    const [searchResp, setSearchResp] = useState(props.searchResp);
    const [query, setQuery] = useState(props.query);
    const [section, setSection] = useState(props.section);
    if(!item || isNaN(item.resultIndex) || item.answerType !== "Entities") {
      return (""); //defensive check
    }
    let eventBlock = searchResp.entities.value[item.resultIndex];
    return (<OneEventCard eventBlock={eventBlock} />);
  } catch(ex) {
    // do nothing for now
  }
  return ("");
}

export const EventsCarousel = props =>  {
  try {
    const [items, setItems] = useState(props.items);
    const [searchResp, setSearchResp] = useState(props.searchResp);
    const [query, setQuery] = useState(props.query);
    const [section, setSection] = useState(props.section);
    if (!items || items.length <= 0 || items[0].answerType != "Entities") {
      return "";
    }
    //make sure it has real event
    let hasEvent = false;
    for (var ix in items) {
      let item = items[ix];
      if (item.answerType==="Entities" && !isNaN(item.resultIndex)) {
        let eventBlock = searchResp.entities.value[item.resultIndex];
        let eventUrl =  GetEventUrl(eventBlock);
        let eventLocation = ( eventBlock && eventBlock.location && eventBlock.location.name ) ?  eventBlock.location.name : null;
        // show event if location, url and date are present
        if (eventLocation && eventUrl && eventBlock.startDate) {
          hasEvent = true;
          break;
        }
      }
    }
    if(!hasEvent) {
      return "";
    }
    return (
      <div className="result-block event-block ">
        <Text className="result-title" id="newSearch.events" fields={{ eventQuery: query }}>Events: {query}</Text>
        <Carousel options={{wrapAround: false, pageDots: false, percentPosition: false, cellAlign: props.isRightToLeft ? 'right' : 'left', rightToLeft: props.isRightToLeft}}>
          {
            items.map(item => {
              if(item.answerType == "Entities") {
                return <Event item={item} searchResp={searchResp} query={query} section={section}/>
              }
            })
          }
        </Carousel>
      </div>
    );
  } catch(ex) {
    // do nothing for now 
  }
  return ("");
}
